var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('core-select-internals',{attrs:{"value":_vm.computedValue,"prefetch":true},on:{"input":_vm.onInput}}),(_vm.isLoading)?_c('div',{staticClass:"mt1"},[_vm._v("Updating...")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }